import styled from 'styled-components';

export const StyledNav = styled.nav<StyleProps>`
  height: 64px;
  background: ${props => props.theme.colors.background.secondary};
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};

  ${props => props.theme.media.small`
    height: 56px;
  `}
`;
